/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.magrathea.MagratheaRunStatus
*/
export var MagratheaRunStatus;
(function (MagratheaRunStatus) {
    MagratheaRunStatus["RUNNING"] = "RUNNING";
    MagratheaRunStatus["DONE"] = "DONE";
    MagratheaRunStatus["FAILED"] = "FAILED";
    MagratheaRunStatus["TERMINATED"] = "TERMINATED";
    MagratheaRunStatus["PAUSED"] = "PAUSED";
})(MagratheaRunStatus || (MagratheaRunStatus = {}));
//# sourceMappingURL=MagratheaRunStatus.js.map